// extracted by mini-css-extract-plugin
module.exports = {"AlertTemplate":"AlertTemplate_AlertTemplate__vOsGF","AlertButton":"AlertTemplate_AlertButton__1yO1N"};